(function () {
  var lastPct = null;

  function animate() {
    var fill = document.querySelector('[data-eatguud-free-delivery-fill]');
    if (!fill) return;

    var target = parseFloat(fill.getAttribute('data-pct')) || 0;

    if (lastPct === null) {
      fill.style.width = target + '%';
    } else if (target !== lastPct) {
      fill.style.width = lastPct + '%';
      void fill.offsetWidth;
      setTimeout(function () {
        fill.style.width = target + '%';
      }, 20);
    }

    lastPct = target;
  }

  function observe() {
    var root = document.getElementById('CartDrawer');
    if (!root) return;

    animate();

    var observer = new MutationObserver(function () {
      animate();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
